<template>
<div class="body1">
 <el-form  :model="form1" :rules="rules" ref="form1" label-width="100px" class="demo-ruleForm">
  <el-form-item label="企业名称" prop="eName">
    <el-input class="input-mr" v-model="form1.eName"></el-input>
  </el-form-item>
   <el-form-item label="统一社会信用代码" prop="eCode">
    <el-input class="input-mr"  v-model="form1.eCode"></el-input>
  </el-form-item>
   <el-form-item label="企业地址" prop="eAddr">
    <el-input class="input-mr"  v-model="form1.eAddr"></el-input>
  </el-form-item>
   <el-form-item label="企业法人" prop="jperson">
    <el-input class="input-mr"  v-model="form1.jperson"></el-input>
  </el-form-item>
  <el-form-item label="手机号" prop="tel">
    <el-input class="input-mr"  v-model="form1.tel"></el-input>
  </el-form-item>
    <el-form-item label="联系人" prop="contacts">
    <el-input class="input-mr"  v-model="form1.contacts"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button class="input-mr"  type="primary" @click="checkForm('form1')"  @keyup.enter.native="checkForm('form1')">添加</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'
export default {
  name: 'adminuseradd',
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('统一社会信用代码不能为空'))
      } else {
        const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的统一社会信用代码'))
        }
      }
    }
    var tel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else {
        const reg = /^1[3456789]\d{9}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号码'))
        }
      }
    }
    var contacts = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系人'))
      } else {
        callback()
      }
    }
    var jperson = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业法人'))
      } else {
        callback()
      }
    }
    var eAddr = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业地址'))
      } else {
        callback()
      }
    }
    var eName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业名称'))
      } else {
        callback()
      }
    }
    return {
      form1: {

      },

      rules: {
        eName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { validator: eName, trigger: 'blur' }
        ],
        eCode: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        eAddr: [
          { required: true, message: '请输入企业地址', trigger: 'blur' },
          { validator: eAddr, trigger: 'blur' }
        ],
        jperson: [
          { required: true, message: '请输入企业法人', trigger: 'blur' },
          { validator: jperson, trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { required: true, validator: tel, trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { validator: contacts, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this
      params.append('id', this.form1.id)
      params.append('eName', this.form1.eName)
      params.append('eCode', this.form1.eCode)
      params.append('eAddr', this.form1.eAddr)
      params.append('jperson', this.form1.jperson)
      params.append('tel', this.form1.tel)
      params.append('contacts', this.form1.contacts)
      if (that.form1.eName === '') { alert('请输入企业名称') } else {
        dataPost(rootPathssb.rootPath + '/admini/user/add', params).then(function (response) {
          that.checkSignin(response.data.result)
          if (response.data.result === 1) {
            alert('保存成功')
            that.$router.push({path: '/adminuserlist'})
            console.log('cg')
          };

          console.log(response.data)
        }).catch(function (error) {
          console.log(error); console.log(2222222222); alert('失败')
        })
      }
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }
  }

}
</script>

<style >
 .dateleft input{

    text-indent: 2em !important;
  }
.body1{
  width:800px;
  margin: 0 auto;
}
  .body1   .el-form-item__label{
  width: 140px !important;
}
.body1 .el-form-item__content{
   margin-left: 140px !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/admin/adminuseradd.vue